module.exports = __webpack_public_path__ + "static/contact_media-749df0032f127cba18f2b7c3f5af7a70.svg";